import React, { FC, useEffect, useState } from "react";
import { FolderDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";
import { Breadcrumbs, useTheme } from "@mui/material";

import { Box, Button, Grid, Stack, Typography } from "@components/base";
import { useUserStore } from "@store/user";
import { useGetFolder } from "@api";
import { Folder } from "@components/common";

const FolderExplorer: FC<{
  folderId: string;
  setFolderId: (id: string) => void;
}> = ({ folderId, setFolderId }) => {
  const { user } = useUserStore();

  const theme = useTheme();

  const { isSuccessGetFolder, folder, isLoadingGetFolder } = useGetFolder(
    user,
    folderId,
  );
  const { folder: rootFolder } = useGetFolder(user, "");
  const [currentFolder, setCurrentFolder] = useState<FolderDto | null>(null);
  const [path, setPath] = useState<FolderDto[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (isSuccessGetFolder && folder) {
      setCurrentFolder(folder);
      setPath([folder]);
    }
  }, [isSuccessGetFolder, folder]);

  const handleOpenFolder = (folderId: string): void => {
    setFolderId(folderId);
  };

  return (
    <Stack gap={4}>
      <Typography textAlign="left" variant="sectionLabel">
        {t("documentHub.foldersSectionTitle")}
      </Typography>
      <Box>
        {/* //TODO update api to finish */}
        {!isLoadingGetFolder && path.length > 0 && (
          <Breadcrumbs aria-label="breadcrumb">
            <Typography color="text.primary" key={folder?.id}>
              {folder?.name === "Root" ? "" : `./${folder?.name}`}
            </Typography>
          </Breadcrumbs>
        )}
      </Box>
      <Grid container spacing={2}>
        {folder?.parentId ? (
          <Grid key={"back-button"}>
            <Button
              variant="text"
              size="small"
              onClick={() => {
                const isParentRoot = currentFolder?.parentId === rootFolder?.id;

                setFolderId(isParentRoot ? "" : currentFolder?.parentId ?? "");
              }}
              startIcon={
                <FeatherIcon
                  color={theme.palette.custom.purple[400]}
                  icon="chevron-left"
                />
              }
            >
              {t("common.back")}
            </Button>
          </Grid>
        ) : (
          <></>
        )}

        {currentFolder?.children.map((folder) => (
          <Grid key={folder.id}>
            <Folder
              folderName={folder.name}
              onClickAction={() => handleOpenFolder(folder.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default FolderExplorer;
